"use strict";
// packages/types/src/invoice.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMethod = exports.BillingReason = exports.InvoiceStatus = void 0;
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "draft";
    InvoiceStatus["OPEN"] = "open";
    InvoiceStatus["PAID"] = "paid";
    InvoiceStatus["UNCOLLECTIBLE"] = "uncollectible";
    InvoiceStatus["VOID"] = "void";
})(InvoiceStatus || (exports.InvoiceStatus = InvoiceStatus = {}));
var BillingReason;
(function (BillingReason) {
    BillingReason["SUBSCRIPTION_CREATE"] = "subscription_create";
    BillingReason["SUBSCRIPTION_UPDATE"] = "subscription_update";
    BillingReason["SUBSCRIPTION"] = "subscription";
    BillingReason["MANUAL"] = "manual";
    BillingReason["UPCOMING"] = "upcoming";
    BillingReason["SUBSCRIPTION_THRESHOLD"] = "subscription_threshold";
})(BillingReason || (exports.BillingReason = BillingReason = {}));
var CollectionMethod;
(function (CollectionMethod) {
    CollectionMethod["CHARGE_AUTOMATICALLY"] = "charge_automatically";
    CollectionMethod["SEND_INVOICE"] = "send_invoice";
})(CollectionMethod || (exports.CollectionMethod = CollectionMethod = {}));
